import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { initialErrors, initialState, passwordRegex } from '../../constants';
import InputForm from '../inputForm/InputForm';
import styles from './form.module.scss';

interface IFormProps {
  onValid: (datas: FormType) => void;
  queries: UrlQueries;
}

const URBANEASE_URL = process.env.REACT_APP_URBANEASE_URL!;

function Form({ onValid, queries }: IFormProps) {
  const [state, setState] = useState<FormType>(initialState);
  const [errors, setErrors] = useState<Errors>(initialErrors);

  const hasError = errors.newPassword || Boolean(errors.newPassword);

  useEffect(() => {
    if (queries?.email)
      setState({ ...state, reference: decodeURIComponent(queries.email) });
  }, [queries]);

  const submitForm = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    const isGood = passwordRegex.test(state.newPassword);
    const isEqual = state.newPassword === state.newPasswordConfirm;
    const checkErrors = { ...initialErrors };

    if (isGood && isEqual) {
      onValid(state);
    } else {
      if (!isGood) {
        checkErrors.newPassword = true;
      }
      if (isGood && !isEqual) {
        checkErrors.newPasswordConfirm = 'Les deux saisies doivent être identiques';
      }

      setErrors(checkErrors);
    }
  };

  const handleChange = (name: string, event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const newValues = { ...state, [name]: value };
    const isGood = passwordRegex.test(newValues.newPassword);

    setState(newValues);

    if (name === 'newPassword' && errors.newPassword !== !isGood) {
      setErrors({ ...errors, newPassword: !isGood });
    }
  };

  const handleResetError = () => setErrors({ ...initialErrors });

  return (
    <form onSubmit={submitForm} className={styles.form} autoComplete="off">
      <InputForm
        label="Email"
        name="reference"
        value={state.reference}
        readOnly
        onChange={handleChange}
        autoComplete="off"
      />
      <InputForm
        autoComplete="new-password"
        label="Mot de passe"
        name="newPassword"
        type="password"
        value={state.newPassword ?? ''}
        placeholder="Nouveau mot de passe"
        onChange={handleChange}
        error={errors.newPassword}
        onResetError={handleResetError}
      />

      <InputForm
        autoComplete="new-password"
        label="Confirmation du mot de passe"
        type="password"
        name="newPasswordConfirm"
        value={state.newPasswordConfirm ?? ''}
        placeholder="Nouveau mot de passe"
        onChange={handleChange}
        error={errors.newPasswordConfirm ?? ''}
      />

      <button type="submit" className={styles.submitBtn} disabled={hasError}>
        Envoyer
      </button>

      <a
        href={URBANEASE_URL}
        className={styles.linkToUrbanease}
        target="_blank"
        rel="noopener noreferrer"
      >
        Retourner sur urbanease
      </a>
    </form>
  );
}

export default Form;
